async function rasterBlobToPng(blob: Blob): Promise<Blob> {
  if (blob.type === 'image/png') return blob;

  const url = URL.createObjectURL(blob);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Could not render image.'));
      img.src = url;
    });

    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Could not prepare image.');

    context.drawImage(image, 0, 0);
    const pngBlob = await new Promise<Blob | null>(resolve => {
      canvas.toBlob(resolve, 'image/png');
    });
    if (!pngBlob) throw new Error('Could not create image.');
    return pngBlob;
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function copyRasterImageToClipboard(src: string): Promise<void> {
  const trimmed = src?.trim();
  if (!trimmed) throw new Error('Nothing to copy.');

  const response = await fetch(trimmed);
  if (!response.ok) throw new Error('Could not load image.');
  const blob = await response.blob();
  if (!blob.type.startsWith('image/')) throw new Error('Could not load image.');

  const pngBlob = await rasterBlobToPng(blob);

  if (typeof navigator !== 'undefined' && navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob })]);
    return;
  }

  throw new Error('Copy is not supported in this browser.');
}
